export const vesselDeploymentImage = '/images/static/deployment/vessel-deployment.png'
export const vesselDeploymentLightImage = '/images/static/deployment/vessel-deployment-light.png'
export const attributeDeploymentImage = '/images/static/deployment/attributes-deployment.png'
export const attributeDeploymentLightImage = '/images/static/deployment/attributes-deployment-light.png'

export const generalImage = '/images/static/general/general.png'
export const cogImage = '/images/static/general/cog.png'

export const autoDeployImage = '/images/static/deployment/auto-deploy.png'
export const includeSubGroupsImage = '/images/static/deployment/include-subgroups.png'

export const computerCommandImage = '/images/static/command/computer-command.png'
export const computerCommandLightImage = '/images/static/command/computer-command-light.png'
export const notifyUserImage = '/images/static/command/notify-user.png'
export const autoCommandImage = '/images/static/command/auto-command.png'
export const backupRestoreImage = '/images/static/command/backup-restore.png'
export const useCredentialsImage = '/images/static/command/use-credentials.png'
export const addRemoveProgramsImage = '/images/static/package/add-remove-programs.png'
